import React, { useState } from "react";
import { Wifi, Phone, Mail } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { siteConfig } from "../mock";
import TermsModal from "./TermsModal";

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  const [termsOpen, setTermsOpen] = useState(false);

  const scrollTo = (sel) => document.querySelector(sel)?.scrollIntoView({ behavior: "smooth" });

  const serviceLinks = [
    { label: t.footer.links.how, href: "#come-funziona" },
    { label: t.footer.links.cards, href: "#card" },
    { label: t.footer.links.coverage, href: "#copertura" },
    { label: t.footer.links.news, href: "#novita" },
  ];

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2 max-w-sm">
          <div className="flex items-center gap-2.5">
            <span className="grid place-items-center w-10 h-10 rounded-xl bg-primary text-white">
              <Wifi className="w-5 h-5" strokeWidth={2.5} />
            </span>
            <span className="leading-tight">
              <span className="block font-display font-extrabold text-[17px] text-white">Hotspot Costarei</span>
              <span className="block text-[11px] font-semibold tracking-[0.2em] text-cyan-400 uppercase">Costa Rei · Cagliari</span>
            </span>
          </div>
          <p className="mt-4 text-[14px] leading-relaxed text-slate-400">{t.footer.tagline}</p>
        </div>

        <div>
          <h4 className="font-display font-bold text-white text-[14px] uppercase tracking-wider">{t.footer.cols.service}</h4>
          <ul className="mt-4 space-y-2.5">
            {serviceLinks.map((l, i) => (
              <li key={i}>
                <button onClick={() => scrollTo(l.href)} className="text-[14px] text-slate-400 hover:text-cyan-400 transition-colors">
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-white text-[14px] uppercase tracking-wider">{t.footer.cols.contact}</h4>
          <ul className="mt-4 space-y-3">
            <li>
              <a href={siteConfig.phoneHref} className="flex items-center gap-2.5 text-[14px] text-slate-400 hover:text-cyan-400 transition-colors">
                <Phone className="w-4 h-4" /> {siteConfig.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${siteConfig.email}`} className="flex items-center gap-2.5 text-[14px] text-slate-400 hover:text-cyan-400 transition-colors">
                <Mail className="w-4 h-4" /> {siteConfig.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[13px] text-slate-500">© {year} Hotspot Costarei. {t.footer.rights}</p>
          <button
            onClick={() => setTermsOpen(true)}
            className="text-[13px] text-slate-400 hover:text-cyan-400 underline underline-offset-4 transition-colors"
          >
            {t.footer.links.terms}
          </button>
        </div>
      </div>

      <TermsModal open={termsOpen} onOpenChange={setTermsOpen} />
    </footer>
  );
}
